import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { updateMetaTags } from "@/utils/metaTagsHelper";

interface MetaTagsProps {
  title: string;
  description: string;
  imageUrl?: string;
  url: string;
  siteName?: string;
}

export const MetaTags = ({ title, description, imageUrl, url, siteName }: MetaTagsProps) => {
  const absoluteImageUrl = imageUrl ? 
    (imageUrl.startsWith('http') ? imageUrl : `${window.location.origin}${imageUrl}`) 
    : undefined;

  // Use the business name as the title without Jitume branding
  const pageTitle = title;
  
  // Document title (browser tab) is just the business name
  const documentTitle = title;

  // Update meta tags directly in the DOM for better WhatsApp compatibility
  useEffect(() => {
    updateMetaTags(pageTitle, description, absoluteImageUrl, url, siteName);
  }, [pageTitle, description, absoluteImageUrl, url, siteName]);

  return (
    <Helmet>
      <title>{documentTitle}</title>
      <meta name="description" content={description} />
      
      {/* OpenGraph tags */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      {absoluteImageUrl && (
        <meta property="og:image" content={absoluteImageUrl} />
      )}
      {siteName && (
        <meta property="og:site_name" content={siteName} />
      )}
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      {absoluteImageUrl && (
        <meta name="twitter:image" content={absoluteImageUrl} />
      )}
    </Helmet>
  );
};
